import React from 'react';

const KYCPolicy = () => {
  return <div>KYCPolicy</div>;
};

export default KYCPolicy;
